import { defineComponent as n, computed as o, openBlock as c, createElementBlock as i, createElementVNode as t, toDisplayString as d, createCommentVNode as f, normalizeStyle as h } from "vue";
const _ = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "ac9bffe9-d852-4d77-8ccc-e8637c31a0e3" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#ac9bffe9-d852-4d77-8ccc-e8637c31a0e3)" }, v = { key: 0 }, k = /* @__PURE__ */ t("path", {
  fill: "#eee",
  d: "M0 0h133.6l35.3 16.7L200.3 0H512v222.6l-22.6 31.7 22.6 35.1V512H200.3l-32-19.8-34.7 19.8H0V289.4l22.1-33.3L0 222.6z"
}, null, -1), p = /* @__PURE__ */ t("path", {
  fill: "#0052b4",
  d: "M133.6 0v222.6H0v66.8h133.6V512h66.7V289.4H512v-66.8H200.3V0h-66.7z"
}, null, -1), g = { fill: "none" }, x = ["r"], H = /* @__PURE__ */ n({
  __name: "fi",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const e = r, l = o(() => 512 + 2 * e.strokeWidth), s = o(() => -e.strokeWidth), a = o(() => 256 + e.strokeWidth / 2);
    return (w, V) => (c(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      t("g", u, [
        e.flagName ? (c(), i("title", v, d(e.flagName), 1)) : f("", !0),
        k,
        p
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: a.value,
          fill: "none",
          style: h({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, _));
  }
});
export {
  H as default
};
//# sourceMappingURL=fi-ed282f21.js.map
